import * as echarts from "echarts";
import {generateDates} from "../../helpers/generateDates";
import {getRandom} from "../../helpers/gerRandom";

export const initDiagramTradingBlock1 = ():void => {
    
    type EChartsOption = echarts.EChartsOption;
    
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const chartDom = document.getElementById("TradingBlock")!;
    const myChart = echarts.init(chartDom);
    let option: EChartsOption;
    
  
    const date = generateDates(100);
    
    const data = [...new Array(10).fill(0).map(() => {
        return getRandom(55, 70);
    }), ...new Array(80).fill(0).map(() => {
        return getRandom(65, 100);
    }), ...new Array(8).fill(0).map(() => {
        return getRandom(100, 110);
    }),120, 120];
    
    // eslint-disable-next-line prefer-const
    option = {
        tooltip: {
            show:false,
        },
        xAxis: {
            show: false,
            data: date
        },
        yAxis: {
            show: false,
            boundaryGap: [0, "100%"]
        },
        grid: {
            left: "-1%",
            right: "-1%",
            bottom: "0%",
            top: "0%"
        },
        series: [
            {
                name: "Fake Data",
                type: "line",
                symbol: "none",
                sampling: "lttb",
                itemStyle: {
                    color: "#5bbf83"
                },
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: "#5bbf83"
                        },
                        {
                            offset: 1,
                            color: "transparent"
                        }
                    ])
                },
                data: data
            }
        ]
    };
    
    option && myChart.setOption(option);
};
